import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import useForm from '../utils/useForm';

const useAchScheduleForm = (onSubmit, values) => {
  const { t } = useTranslation();

  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: t(
          'AddOrEditPage.AddOrEditLoan.Sections.AchSchedule.ACH Schedule'
        ),
        isTitleHidden: false,
        fields: [
          {
            title: t('common.forms.labels.ACH'),
            name: 'ach_type',
            type: 'select',
            required: true,
            options: [
              {
                value: 'automatic',
                label: t('common.forms.options.Automatic'),
              },
              { value: 'manual', label: t('common.forms.options.Manual') },
              { value: 'off', label: t('common.forms.options.Off') },
            ],
          },
          {
            title: t('common.forms.labels.Extra towards principal'),
            name: 'ach_schedule.extra_principal',
            type: 'currency',
            required: false,
            isHidden: (vals) => vals.ach_type !== 'automatic',
          },
        ],
      },
    ],
    [t]
  );

  return useForm({ fields, onSubmit: submitHandler, values });
};

export default useAchScheduleForm;
